import React from 'react';
import Estatus from '../../componentes/Estatus';
import Listados from '../../contenedores/Listados';
import { ENFERMEDADES } from '../../configuraciones/endpoints';

const cabeceros = [
  { label: 'Código', key: 'id' },
  { label: 'Nombre', key: 'nombre' },
  { label: 'Tipo', transform: ({ tipoEnfermedad }) => tipoEnfermedad?.nombre },
  { label: 'Estatus', transform: ({ estatus }) => <Estatus activo={estatus} /> },
];

const Enfermedades = ({ history, location }) => {
  return <Listados
    titulo="Enfermedades/Plagas"
    placeHolder="Búsqueda por nombre"
    history={history}
    location={location}
    showActions
    cabeceros={cabeceros || []}
    apiKey={ENFERMEDADES}
  />;
};

export default Enfermedades;